import { create, StateCreator } from "zustand";
import { persist, StorageValue } from "zustand/middleware";

type Topic = "restaurant" | undefined;
interface IStore {
  token: string | null;
  notificationToken?: string | null;
  idAddress?: string | undefined;
  topic?: Topic;
  setTopic?: (topic: Topic) => void;
  setToken?: (token: string | null) => void;
  setNotificationToken?: (notificationToken: string) => void;
  setAddress?: (idAddress: string | undefined) => void;
  cleanToken?: () => void;
}

const store: StateCreator<IStore> = (set) => ({
  token: "", // Is important that token is initialized with "" because the hook useRedirection need it
  notificationToken: "",
  idAddress: "",
  topic: undefined,
  setTopic: (topic) => set(() => ({ topic })),
  setToken: (token) => set(() => ({ token })),
  setNotificationToken: (notificationToken) =>
    set(() => ({ notificationToken })),
  setAddress: (idAddress) => set(() => ({ idAddress })),
  cleanToken: () =>
    set(() => ({ token: null, notificationToken: null, topic: undefined })),
});

export const useStore = create<IStore, [["zustand/persist", unknown]]>(
  persist(store, {
    name: "Alegriia",
    storage: {
      getItem: (name) => {
        const str = sessionStorage.getItem(name);
        if (!str) return null;
        const data: { token: string; idAddress: string } = JSON.parse(str);
        return { state: { ...data } };
      },
      setItem: (name, newValue: StorageValue<IStore>) => {
        const str = JSON.stringify(newValue.state);
        sessionStorage.setItem(name, str);
      },
      removeItem: (name) => sessionStorage.removeItem(name),
    },
  })
);
